const isItemToString = (is = true, yes = '', no = 'not ') => `${is ? yes : no}`;
export default isItemToString;
//# sourceMappingURL=is_item_to_string.js.map